import React from 'react';
import PropTypes from 'prop-types';

import AddControl from './add_control';
import Step from './step';

import { connect } from 'react-redux';
import { addStep } from './store/workflow/actions';

export class TaskWorkflow extends React.Component {
  static propTypes = {
    addStep: PropTypes.func.isRequired,
    workflow: PropTypes.shape({
      steps: PropTypes.array.isRequired
    }).isRequired
  }

  render() {
    return <React.Fragment>
      {this.renderSteps()}
      <AddControl label="Add Step" onClick={this.props.addStep} />
    </React.Fragment>;
  }

  renderSteps() {
    return this.props.workflow.steps.map((step, i) => (
      <Step index={i} key={i} step={step} />
    ));
  }
}

const mapStateToProps = state => ({
  workflow: state.workflow
});

const mapDispatchToProps = {
  addStep
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskWorkflow);
